<style scoped lang="sass">
.content
  padding: 20px
  overflow: hidden

  .content_left
    width: 230px
    background: #fff
    float: left

    .logo
      height: 100px

    .el-menu
      border: 0

  .content_right
    margin-left: 25px
    width: 845px
    background: #fff
    float: left

    .search_box
      display: flex
      padding: 30px 44px
      border-bottom: 1px solid #f5f5f5

      ::v-deep
        .el-input__inner
          border-right: 0
          border-radius: 0

      .button
        display: flex
        justify-content: center
        align-items: center
        width: 55px
        color: #fff
        background: #00ace9

        i
          font-size: 16px

    .content_right_box
      padding: 18px 45px
      cursor: pointer

.each_question
  line-height: 50px
  font-size: 30px
  color: #000
  &:hover
    color: #4B90FF
</style>

<template>
  <div class="content">
    <div class="content_left">
      <div class="logo" />
      <el-menu ref="menu" :default-active="defaultActiveIndex" unique-opened>
        <el-submenu
          v-for="(item, index) in navigationList"
          :key="index"
          :index="String(index + 1)"
        >
          <template slot="title">
            <span>{{ item.name }}</span>
          </template>
          <el-menu-item-group>
            <el-menu-item
              v-for="(navigation, navigationIndex) in item.list"
              :key="navigationIndex"
              :index="String(navigation.category_id)"
              @click="getMenuSelectIndex(navigation.category_id)"
              >{{ navigation.name }}</el-menu-item
            >
          </el-menu-item-group>
        </el-submenu>
      </el-menu>
    </div>
    <div class="content_right">
      <div class="search_box">问题列表</div>
      <div class="content_right_box">
        <div
          v-for="(item, index) in questionsAndAnswersList"
          :key="item.id"
          class="each_question"
          @click="popup(item.answer)"
        >
          <span class="index">{{ index + 1 }}、</span>
          <span class="content">{{ item.question }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      defaultActiveIndex: 0,
      navigationList: [],
      questionsAndAnswersList: []
    };
  },
  async mounted() {
    document.title = '新手指南';
    await this.getData();
    this.defaultActiveIndex = this.navigationList[0].list[0].category_id;
    await this.getQuestionData();
  },
  methods: {
    popup(answer) {
      this.$toast(answer);
    },

    async getData() {
      const url =
        'http://dev.backstage.shouhubeibei.com/api/handbook/Handbook/getHeadline';
      const res = await this.$http.post(url, {
        type: 2
      });
      let sum = 0;
      this.navigationList = res.map(item => {
        sum += item.list.length;
        return {
          ...item,
          totalNow: sum - item.list.length
        };
      });
    },

    async getMenuSelectIndex(categoryId) {
      await this.getQuestionData(categoryId);
    },

    async getQuestionData(
      categoryId = this.navigationList[0].list[0].category_id
    ) {
      const url =
        'http://dev.backstage.shouhubeibei.com/api/handbook/Handbook/getQAndA';

      const s = axios.create({
        baseURL: 'https://dev.standard.shouhubeibei.com',
        timeout: 30000
      });
      const formData = new FormData();
      formData.append('category_id', categoryId);
      const res = await s.post(url, formData);
      console.log(res);
      this.questionsAndAnswersList = res.data.data;
    }
  }
};
</script>
